import { Camera } from "../../../GL/scene/camera.js";
import { PhotoshopController } from "../../../photoshopController.js";

export class LayerWidget {

    static widgetUniqueId = 0;
    _parent: HTMLElement | null;
    layer: any;
    engine: any;
    camera: Camera;
    operation: any;
    _controller: PhotoshopController;
    _active: any | null;
    _visible: boolean;
    _widgetUniqueId: number;
    filterName: HTMLElement | null;

    static getUniqueWidgetId() {
        return LayerWidget.widgetUniqueId++;
    }

    constructor(parent: HTMLElement | null, layer: any, engine: any, camera: Camera, operation: any, controller: PhotoshopController) {
        this._parent = parent;
        this.layer = layer;
        this.engine = engine;
        this.camera = camera;
        this.operation = operation;
        this._controller = controller;
        this._active = null;
        this._visible = true;
        this._widgetUniqueId = LayerWidget.getUniqueWidgetId();
        if (this._parent) {
            this._parent.innerHTML += this.html();
        }
        setTimeout(() => {
            this.initEvent();
        }, 0);
        this.updateClass();
    }

    get active() {
        return this._active;
    }

    set active(value) {
        this._active = value;
    }

    get visible() {
        return this._visible;
    }

    set visible(value) {
        this._visible = value;
    }

    get parent() {
        return this._parent;
    }

    get controller() {
        return this._controller;
    }

    initEvent() {
        const eyeElem = document.getElementById("filter-eye-" + this._widgetUniqueId);
        if (eyeElem) {
            eyeElem.addEventListener("click", this.filter_eyeOnClick.bind(this));
        }
        const selectedElem = document.getElementById("filter-selected-" + this._widgetUniqueId);
        if (selectedElem) {
            selectedElem.addEventListener("click", this.filter_selected.bind(this));
        }
        const closeElem = document.getElementById("filter-close-" + this._widgetUniqueId);
        if (closeElem) {
            closeElem.addEventListener("click", this.filter_close.bind(this));
        }
    }

    deleteEvents() {
        const eyeElem = document.getElementById("filter-eye-" + this._widgetUniqueId);
        if (eyeElem) {
            eyeElem.removeEventListener("click", this.filter_eyeOnClick.bind(this));
        }
        const selectedElem = document.getElementById("filter-selected-" + this._widgetUniqueId);
        if (selectedElem) {
            selectedElem.removeEventListener("click", this.filter_selected.bind(this));
        }
        const closeElem = document.getElementById("filter-close-" + this._widgetUniqueId);
        if (closeElem) {
            closeElem.removeEventListener("click", this.filter_close.bind(this));
        }
    }

    header() {
        return `
        <div id="filter-`+ this._widgetUniqueId + `" class="col s12 layer">
            <div class="col center-align" style="float: left;">
                <i id="filter-eye-`+ this._widgetUniqueId + `" class="fas"></i>
            </div>
        `;
    }

    html() {
        return this.header() + `
            <span id="filter-selected-`+ this._widgetUniqueId + `" style="width: 100%" class="col"></span>
        ` + this.footer();
    }

    footer() {
        return `
            <div class="col right center-align">
                <i id="filter-close-`+ this._widgetUniqueId + `" class="far fa-trash-alt"></i>
            </div>
        </div>
        `;
    }

    filter_eyeOnClick() {
        this.operation.active = !this.operation.activated;
        this.updateClass();
        this.controller.update()
    }

    filter_selected() {
        if (!this.controller.PSEngine) {
            return;
        }
        this.operation.touch();
        this.controller.PSEngine.activeLayer = this.layer;
        this.controller.setActiveOperation(this.operation.program, this.operation);
        this.updateClass();
        this.controller.update();
    }

    filter_close() {
        this.deleteEvents();
        this.destroyLayer();
    }

    updateClass() {
        if (this.operation.activated) {
            const eyeElem = document.getElementById("filter-eye-" + this._widgetUniqueId);
            if (eyeElem) {
                eyeElem.classList.add('fa-eye');
            }
        } else {
            const eyeElem = document.getElementById("filter-eye-" + this._widgetUniqueId);
            if (eyeElem) {
                eyeElem.classList.remove('fa-eye');
            }
        }
        if (!this.operation.activated) {
            const eyeElem = document.getElementById("filter-eye-" + this._widgetUniqueId);
            if (eyeElem) {
                eyeElem.classList.add('fa-eye-slash');
            }
        } else {
            const eyeElem = document.getElementById("filter-eye-" + this._widgetUniqueId);
            if (eyeElem) {
                eyeElem.classList.remove('fa-eye-slash');
            }
        }
        this.filterName = document.getElementById("filter-selected-" + this._widgetUniqueId);
        if (this.filterName) {
            this.filterName.textContent = this.operation.name;
        }
        if (this.controller.photoshopWidget.activeOperationWidget) {
            this.controller.photoshopWidget.activeOperationWidget.updateClass();
        }
    }

    destroyLayer() {
        if (this.operation) {
            this.layer.deleteOperation(this.operation);
            this.engine.render(this.camera);
        } else {
            this.engine.deleteLayer(this.layer);
            this.engine.render(this.camera);
            if (this.controller.photoshopWidget.activeOperationWidget) {
                this.controller.photoshopWidget.activeOperationWidget.updateIf();
            }
        }
        this.layer.deleteOperation(this.operation);
        this.controller.setActiveOperation(null);
        this.controller.photoshopWidget.dataPanelWidget.layersWidget.refreshLayers();
    }
}
